import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import 'rxjs/add/observable/throw';

import * as _ from 'underscore';

// Service
import { UserListService } from '../../service/user-list/user-list.service';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	providers: [
		UserListService,
		HttpModule
	]
})
export class UserListComponent implements OnInit {

	private token;
	public users: any[];
	public groupsSearch: any[];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	user: FormGroup;

	constructor(fb: FormBuilder, private userListService: UserListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.user = fb.group({
			'Nome': '',
			'Login': '',
			'EmpresaID': '',
			'TipoAcesso': '',
			'Grupo': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.userListService.listGroup(this.token).subscribe(result => {
			console.log(result);
			this.groupsSearch = result.Result;
		}, error => {
			console.log(error);
		})
		this.searchUser(this.user.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchUser(this.user.value, this.currentPage, false);
	}

	searchUser(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.userListService.searchUser(this.token, value.Nome, value.Login, value.Grupo, value.EmpresaID, value.TipoAcesso, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.users = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchUser(this.user.value, $event, false);
	}
}



// WEBPACK FOOTER //
// ./src/app/user/component/user-list/user-list.component.ts